var _excluded = [
  'scroll',
  'columns',
  'cacheId',
  'prefixCls',
  'autoSize',
  'rowSelectionEnhance',
  'onTableScroll',
];
var _templateObject;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}
import React, { useRef, forwardRef, useImperativeHandle, useMemo } from 'react';
import { Table } from 'udesk-ui';
import styled from 'styled-components';
import { usePrefixCls } from '../utils';
import {
  useMemoScrollPosition,
  useScroll as useTableScrollProps,
  useRowSelection,
  useColumnsFormat,
} from './utils';
import './style/index';
var TableWrap = styled.div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  width: 100%;\n  height: 100%;\n  ',
      ' {\n    height: 100%;\n  }\n  ',
      ' {\n    min-height: 32px;\n  }\n  ',
      '\n',
    ])),
  function (props) {
    return '.'.concat(props.prefixCls, '-table-wrapper');
  },
  function (props) {
    return '.'.concat(props.prefixCls, '-pagination');
  },
  function (props) {
    return props.columnsEllipsis.map(function (column) {
      return '.gm-ui-table-col-max-width-'
        .concat(column.key, ' {\n     max-width: ')
        .concat(column.width, 'px;\n  }');
    });
  },
);
var MemoTable = /*#__PURE__*/ forwardRef(function (props, ref) {
  var _rowSelectionEnhance$, _rowSelectionEnhance$2;
  var propsScroll = props.scroll,
    propsColumns = props.columns,
    _props$cacheId = props.cacheId,
    cacheId = _props$cacheId === void 0 ? '' : _props$cacheId,
    customizePrefixCls = props.prefixCls,
    autoSize = props.autoSize,
    rowSelectionEnhance = props.rowSelectionEnhance,
    onTableScroll = props.onTableScroll,
    antdProps = _objectWithoutProperties(props, _excluded);
  //   const [columns, setColumns] = useState<TableProps['columns']>([]);
  var _usePrefixCls = usePrefixCls('table-body', customizePrefixCls),
    _usePrefixCls2 = _slicedToArray(_usePrefixCls, 2),
    tableBodyPrefixCls = _usePrefixCls2[0],
    prefixCls = _usePrefixCls2[1];
  var _usePrefixCls3 = usePrefixCls('memo-table', customizePrefixCls),
    _usePrefixCls4 = _slicedToArray(_usePrefixCls3, 1),
    tableWrapPrefixCls = _usePrefixCls4[0];
  var wrapRef = useRef(null);
  var scroll = useTableScrollProps(
    {
      wrapRef: wrapRef,
      propsScroll: propsScroll,
      prefixCls: prefixCls,
      dataSource: antdProps.dataSource,
    },
    [propsScroll],
  );
  var _useMemoScrollPositio = useMemoScrollPosition({
      cacheId: cacheId,
      tableBodyPrefixCls: tableBodyPrefixCls,
      wrapRef: wrapRef,
      dataSource: antdProps.dataSource,
      columns: propsColumns,
    }),
    tryToSavePrevScrollPosition = _useMemoScrollPositio.tryToSavePrevScrollPosition,
    tryToResetPrevScrollPosition = _useMemoScrollPositio.tryToResetPrevScrollPosition,
    storage = _useMemoScrollPositio.storage;
  var _useRowSelection = useRowSelection(
      _typeof(rowSelectionEnhance) === 'object'
        ? (_rowSelectionEnhance$ =
            rowSelectionEnhance === null || rowSelectionEnhance === void 0
              ? void 0
              : rowSelectionEnhance.type) !== null && _rowSelectionEnhance$ !== void 0
          ? _rowSelectionEnhance$
          : 'checkbox'
        : undefined,
      rowSelectionEnhance,
    ),
    rowSelection = _useRowSelection.rowSelection,
    rowSelectionInstance = _useRowSelection.instance;
  var columns = useColumnsFormat(propsColumns);
  useImperativeHandle(ref, function () {
    return {
      clearScrollPosition: function clearScrollPosition() {
        return storage.delete();
      },
      scrollTo: tryToResetPrevScrollPosition,
      resetToEmpty: rowSelectionInstance.resetToEmpty,
    };
  });
  var columnsEllipsis = useMemo(
    function () {
      var _columns$filter;
      return (_columns$filter =
        columns === null || columns === void 0
          ? void 0
          : columns.filter(function (i) {
              return i.ellipsis;
            })) !== null && _columns$filter !== void 0
        ? _columns$filter
        : [];
    },
    [columns],
  );
  return /*#__PURE__*/ React.createElement(
    TableWrap,
    {
      columnsEllipsis: columnsEllipsis,
      onScrollCapture: function onScrollCapture() {
        onTableScroll && requestAnimationFrame(onTableScroll);
        requestAnimationFrame(tryToSavePrevScrollPosition);
      },
      className: tableWrapPrefixCls,
      ref: wrapRef,
      prefixCls: prefixCls,
    },
    /*#__PURE__*/ React.createElement(
      Table,
      _objectSpread(
        _objectSpread(
          {
            rowSelection: rowSelection,
          },
          antdProps,
        ),
        {},
        {
          scroll: autoSize ? scroll : propsScroll,
          columns: columns,
          rowKey:
            (_rowSelectionEnhance$2 =
              rowSelectionEnhance === null || rowSelectionEnhance === void 0
                ? void 0
                : rowSelectionEnhance.rowKeysFieldName) !== null &&
            _rowSelectionEnhance$2 !== void 0
              ? _rowSelectionEnhance$2
              : 'id',
        },
      ),
    ),
  );
});
MemoTable.defaultProps = {
  autoSize: true,
  cacheId: '',
};
export default /*#__PURE__*/ React.memo(MemoTable);
